import React from 'react';
import { UserPanelContainer, AvatarContainer, NaviContainer } from './UserPanel.style';
import { Avatar } from '../Avatar';
/* Komponent panelu użytkownika */
export var UserPanel = function (props) {
    var user = props.user;
    return (React.createElement(UserPanelContainer, { opened: props.opened },
        React.createElement("div", null,
            React.createElement(AvatarContainer, null,
                React.createElement(Avatar, { avatar: user.avatar })),
            React.createElement(NaviContainer, null,
                React.createElement("p", null,
                    user.firstName,
                    " ",
                    user.lastName),
                React.createElement("span", null, user.role),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("button", { "data-cy": 'btnLogout', className: 'btn', onClick: props.onLogout }, props.translations.logout))))),
        React.createElement(React.Fragment, null, props.children)));
};
